import { App_User } from '@/data/user_info'

import WX_API from '@/utils/wx_api'

export default {
    data () {
        return {
            official_customer_service: {
                wx_username: ''
            }
        }
    },
    mounted () {
        App_User.official_customer_service().then((official_customer_service) => {
            this.official_customer_service = official_customer_service
        }).catch(console.error)
    },
    methods: {
        copyCustomerWeixin () {
            const { wx_username } = this.official_customer_service
            if (wx_username) {
                WX_API.setClipboardData(wx_username)
            }
        }
    }
}
